<template>
  <div>
    <div class="tw-border-b tw-border-b-primary-grey-200 tw-mb-4">
      <CbIconAddProducts class="tw-mb-4" :width="48" color="black" tile />
      <p class="tw-text-lg tw-font-medium tw-mb-4">
        {{ t("outlook-add-in-title") }}
      </p>
      <p class="tw-mb-4">
        {{ t("outlook-add-in-value") }}
      </p>
      <t-link
        :href="EXTERNAL_DOCS_LINKS.OUTLOOK_ADD_IN_DEPLOY_INSTRUCTIONS"
        :is-external="true"
        :string="t('learn-more')"
        data-test-id="m365-contact-support-link"
        class="tw-underline tw-mb-4"
      />
    </div>
    <div class="tw-mb-4">
      <div class="tw-flex tw-items-center tw-mb-4">
        <span
          class="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50 tw-mr-4"
          >1</span
        >
        <p>{{ t("step-add-in-link") }}</p>
      </div>
      <div
        class="tw-flex tw-items-center tw-border tw-border-primary-grey-100 tw-rounded-md tw-p-2 tw-bg-primary-grey-50"
      >
        <span
          class="tw-flex-1 tw-min-w-0 tw-select-text tw-truncate tw-text-primary-grey-300"
        >
          {{ MANIFEST_LINK }}
        </span>
        <t-copy-button
          class="tw-ml-2"
          :value="MANIFEST_LINK"
          :label="t('copy')"
        />
      </div>
    </div>
    <div>
      <div class="tw-flex tw-items-center tw-mb-4">
        <span
          class="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50 tw-mr-4"
          >2</span
        >
        <p>{{ t("outlook-add-in-title") }}</p>
      </div>
      <div class="tw-border tw-border-primary-grey-100 tw-rounded-xl tw-p-4">
        <ol class="tw-list-decimal tw-pl-5">
          <li>
            <t-link
              :is-external="true"
              :href="'https://admin.microsoft.com/Adminportal/Home#/Settings/IntegratedApps'"
              :string="t('open-admin-center')"
              dataTestId="customer-settings-connections-ndr-settings-link"
            />
          </li>
          <li>{{ t("assign-deploy") }}</li>
        </ol>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { CbIconAddProducts } from "@/components/cybersentriq-ui/icons";
import TLink from "@/components/TLink";
import TCopyButton from "@/components/TCopyButton/TCopyButton.vue";
import { useI18n } from "vue-i18n";
import { EXTERNAL_DOCS_LINKS } from "@/constants/externalDocsLinks.ts";

const { t } = useI18n();

const MANIFEST_LINK = "https://protect.titanhq.com/manifest.xml";
</script>
